// extracted by mini-css-extract-plugin
export default {"price":"__-z","onSale":"aaa-z","msrpLabelPrice":"baa-z","msrpLabel":"caa-z","originalPrice":"daa-z"};